"use client";

import Script from "next/script";

export function TikTokPixel({ pixelId }: { pixelId?: string | null }) {
    if (!pixelId) return null;

    return (
        <Script
            id="tiktok-pixel"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
                __html: `
        !function (w, d, t) {
          w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","setCustomProperties","trackAndSend","identifyAndSend"],ttq.setAndSend=function(t,e){ttq.instance(t).setAndSend(e)};ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndSend(ttq,ttq.methods[n]);return e},ttq.load=function(e,i){var n="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=i||{};var o=d.createElement("script");o.type="text/javascript",o.async=!0,o.src=n;var a=d.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
          ttq.load('${pixelId}');
          ttq.page();
        }(window, document, 'ttq');
      `,
            }}
        />
    );
}
